var $92fee9698e4d675a$exports = {};
$92fee9698e4d675a$exports = {
    "alpha": `Alpha`,
    "blue": `Azul`,
    "brightness": `Brillo`,
    "green": `Verde`,
    "hue": `Tono`,
    "lightness": `Luminosidad`,
    "red": `Rojo`,
    "saturation": `Saturaci\xf3n`
};


export {$92fee9698e4d675a$exports as default};
//# sourceMappingURL=es-ES.module.js.map
